var _defs, _path, _path2, _g, _ellipse, _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle, _circle2, _path3, _path4, _rect19, _path5, _path6, _path7, _rect20, _polygon3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon4, _path19, _polygon5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse2, _path41, _path42, _path43, _path44, _path45, _ellipse3, _path46, _path47, _path48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirconditionerrepair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b80e13d0-8a51-44cf-b7d6-3a39d2e0b213",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fea183e0-07c3-49bf-b1c2-26bb59e00ff7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bb6043a8-b0fc-4453-b0f6-9088deb52c77",
    "data-name": "SVGID",
    d: "M508,653.52c199.94-81.32,267.65-310,267.65-310C829.91,139.28,628.13,55.64,628.13,55.64,337.43-71.08,245.2,116.17,245.2,116.17c-19.85,47.91-72.77,111.38-72.77,111.38l-34,43.44a310,310,0,0,0-20.35,29.26C43.75,421.65,87.34,494.71,87.34,494.71S237.2,754,508,653.52Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e1b8fffb-17cf-49a9-bb2b-397bf38f2ba0",
    "data-name": "SVGID",
    d: "M508,653.52c199.94-81.32,267.65-310,267.65-310C829.91,139.28,628.13,55.64,628.13,55.64,337.43-71.08,245.2,116.17,245.2,116.17c-19.85,47.91-72.77,111.38-72.77,111.38l-34,43.44a310,310,0,0,0-20.35,29.26C43.75,421.65,87.34,494.71,87.34,494.71S237.2,754,508,653.52Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ef8f6749-7f16-4174-b2bd-4bfd4b50bf95",
    "data-name": "SVGID",
    d: "M508,653.52c199.94-81.32,267.65-310,267.65-310C829.91,139.28,628.13,55.64,628.13,55.64,337.43-71.08,245.2,116.17,245.2,116.17c-19.85,47.91-72.77,111.38-72.77,111.38l-34,43.44a310,310,0,0,0-20.35,29.26C43.75,421.65,87.34,494.71,87.34,494.71S237.2,754,508,653.52Z",
    fill: "#fff",
    opacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fea183e0-07c3-49bf-b1c2-26bb59e00ff7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.88,
    y: 679.69,
    width: 12.21,
    height: 20.35,
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.21,
    y: 679.69,
    width: 12.21,
    height: 20.35,
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.88,
    y: 679.69,
    width: 12.21,
    height: 20.35,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.21,
    y: 679.69,
    width: 12.21,
    height: 20.35,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 455.87,
    width: 220.56,
    height: 232.77,
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.37,
    y: 455.87,
    width: 220.56,
    height: 232.77,
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.58,
    y: 478.66,
    width: 195.33,
    height: 32.56,
    rx: 1.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.58,
    y: 522.61,
    width: 195.33,
    height: 32.56,
    rx: 1.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.58,
    y: 562.09,
    width: 195.33,
    height: 103.36,
    rx: 1.04,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.24,
    cy: 536.04,
    r: 4.48,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.24,
    cy: 496.57,
    r: 4.48,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.81,368.78a.41.41,0,0,1,.09-.2l.28-.52a21.65,21.65,0,0,1,1.21-1.94,20.85,20.85,0,0,1,6.09-5.78,15.09,15.09,0,0,1,5.5-2,13.64,13.64,0,0,1,6.67.7,10.92,10.92,0,0,1,5.83,4.74c1.3,2.29,1.72,5,2.49,7.55a13.71,13.71,0,0,0,1.6,3.66,11,11,0,0,0,2.71,2.66c1,.76,2.09,1.43,3.06,2.22a13.85,13.85,0,0,1,2.44,2.69,16.41,16.41,0,0,1,2.53,6.23,21.51,21.51,0,0,1,.34,5.83,44.38,44.38,0,0,1-1.48,8.32c-.26,1-.48,1.7-.63,2.2a5.15,5.15,0,0,1-.24.76,5.4,5.4,0,0,1,.16-.78l.52-2.23a46.43,46.43,0,0,0,1.35-8.28,23.56,23.56,0,0,0-.38-5.75,16.67,16.67,0,0,0-2.53-6.09,12.94,12.94,0,0,0-2.43-2.58c-1-.77-2-1.44-3.06-2.21a11.16,11.16,0,0,1-2.8-2.85,14,14,0,0,1-1.66-3.73c-.78-2.61-1.22-5.27-2.43-7.46a10.5,10.5,0,0,0-5.47-4.5,13.2,13.2,0,0,0-6.47-.71,14.76,14.76,0,0,0-5.38,1.91,21.18,21.18,0,0,0-6.09,5.61c-.6.79-1,1.44-1.31,1.88C151.16,368.34,151,368.56,150.81,368.78Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.43,378.21c-.71-.66-1.05-.21-2,0a5.85,5.85,0,0,0-2.57,1.29,10.81,10.81,0,0,0-3.51,11.35,8.44,8.44,0,0,0,7.75-12.69",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35,365c-.36-.9-.86-.64-1.8-.89a5.81,5.81,0,0,0-2.87,0,10.83,10.83,0,0,0-8.05,8.74,8.44,8.44,0,0,0,12.46-8.11",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,396.11a9.75,9.75,0,0,0-13.75-1,9.85,9.85,0,0,0-1.59,1.76,12.17,12.17,0,0,0,7.95,3.13,12.48,12.48,0,0,0,8-3.24",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,382.74a9.89,9.89,0,0,0,10-11.79,8.86,8.86,0,0,0-10.3,11.69",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,367A9.87,9.87,0,0,0,191,361.34a9.24,9.24,0,0,0,.56-2.14,8.87,8.87,0,0,0-13.6,7.6",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.78,361.87A9.89,9.89,0,0,0,162,367.55a10.44,10.44,0,0,0-.56,2.13,8.88,8.88,0,0,0,13.62-7.6",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.69,359.11A9.86,9.86,0,0,0,176,344.59a8.87,8.87,0,0,0-5.57,14.54",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.21,359.61A9.87,9.87,0,0,0,154.29,347a9.62,9.62,0,0,0-2.18-.52,8.88,8.88,0,0,0,7.87,13.4",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "202.47 432.54 208.05 395.42 165.26 395.96 169.47 432.06",
    fill: "#2f2e41",
    "data-secondary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,389a7.31,7.31,0,0,1-7.11.6,7.69,7.69,0,0,1-3.89-6.09,8.79,8.79,0,0,1,7.1-.37,8.68,8.68,0,0,1,4.72,5.29",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.43,396.56a7.29,7.29,0,0,1-7.1.6,7.71,7.71,0,0,1-3.89-6.09,8.21,8.21,0,0,1,11.14,3.27,7.94,7.94,0,0,1,.66,1.6",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,379.7a7.29,7.29,0,0,1-5.61,4.41,7.67,7.67,0,0,1-6.62-3,8.21,8.21,0,0,1,12.57-2.39",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.28,388.44a7.31,7.31,0,0,1,6.38,3.15,7.7,7.7,0,0,1,.15,7.31,8.68,8.68,0,0,1-6.25-3.36,8.56,8.56,0,0,1-1.31-7",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.38,402.23a7.28,7.28,0,0,1-.17,7.12,7.68,7.68,0,0,1-6.53,3.2,8.75,8.75,0,0,1,.41-7.08c1.13-2.05,3.15-3.06,5.7-3.66",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,403.86a4.82,4.82,0,0,1,1.69-1.09,7.28,7.28,0,0,1,2.31-.4,27.94,27.94,0,0,1,3.17.18,9.3,9.3,0,0,0,3.89-.32,6,6,0,0,0,3.22-3.15,17.35,17.35,0,0,0,1.39-4.74,13.85,13.85,0,0,1,1.65-4.87,17.54,17.54,0,0,1,3.65-3.65,17.23,17.23,0,0,0,3.47-3.51,11.59,11.59,0,0,0,1.72-8.05,11.4,11.4,0,0,0-2.13-5.17,9.14,9.14,0,0,0-1-1.12,2.23,2.23,0,0,0-.4-.35,2.72,2.72,0,0,0,.34.42,11,11,0,0,1,2.88,6.28,11.4,11.4,0,0,1-1.78,7.77,17.49,17.49,0,0,1-3.41,3.41,17.78,17.78,0,0,0-3.72,3.78,14,14,0,0,0-1.7,5,17.32,17.32,0,0,1-1.32,4.62,5.57,5.57,0,0,1-3,2.94,9.09,9.09,0,0,1-3.74.37,26.1,26.1,0,0,0-3.19-.13,7.72,7.72,0,0,0-2.37.5,4,4,0,0,0-1.28.84,1.93,1.93,0,0,0-.27.3C150,403.81,150,403.85,150,403.86Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,403.86a4.82,4.82,0,0,1,1.69-1.09,7.28,7.28,0,0,1,2.31-.4,27.94,27.94,0,0,1,3.17.18,9.3,9.3,0,0,0,3.89-.32,6,6,0,0,0,3.22-3.15,17.35,17.35,0,0,0,1.39-4.74,13.85,13.85,0,0,1,1.65-4.87,17.54,17.54,0,0,1,3.65-3.65,17.23,17.23,0,0,0,3.47-3.51,11.59,11.59,0,0,0,1.72-8.05,11.4,11.4,0,0,0-2.13-5.17,9.14,9.14,0,0,0-1-1.12,2.23,2.23,0,0,0-.4-.35,2.72,2.72,0,0,0,.34.42,11,11,0,0,1,2.88,6.28,11.4,11.4,0,0,1-1.78,7.77,17.49,17.49,0,0,1-3.41,3.41,17.78,17.78,0,0,0-3.72,3.78,14,14,0,0,0-1.7,5,17.32,17.32,0,0,1-1.32,4.62,5.57,5.57,0,0,1-3,2.94,9.09,9.09,0,0,1-3.74.37,26.1,26.1,0,0,0-3.19-.13,7.72,7.72,0,0,0-2.37.5,4,4,0,0,0-1.28.84,1.93,1.93,0,0,0-.27.3C150,403.81,150,403.85,150,403.86Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7,407.44a10.82,10.82,0,0,1,14.62-10.66,18.1,18.1,0,0,1-14.27,10.54",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.53,408.94c2.09,2.3,2,6,.46,8.72a19.67,19.67,0,0,1-6.66,6.39,14.08,14.08,0,0,1,6.09-15.95",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.39,398.16a12.49,12.49,0,0,1-13.67,11.19c-.18,0-.35,0-.53-.06.82-3.36,2.16-6.76,4.76-9s6.7-3.13,9.58-1.22",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.45,394.72c.53-3.06,3.55-5.27,6.64-5.56a12.79,12.79,0,0,1,8.64,2.89,11.23,11.23,0,0,1-15.3,1.52",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,420.78c2.93,2.5,3.65,7,2.43,10.64a17.79,17.79,0,0,1-7.3,8.73,23.2,23.2,0,0,1-1.37-11.31,11.89,11.89,0,0,1,6.44-9",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.93,386.14a9,9,0,0,0-12.53-2.47,9.35,9.35,0,0,0-1.82,1.62,7.79,7.79,0,0,0,14.08.37",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.33,377.3A11.74,11.74,0,0,0,236,369.5a12.4,12.4,0,0,0,.32-1.37,26.57,26.57,0,0,0-7.07.1,11.44,11.44,0,0,0-6.26,3.08,6.21,6.21,0,0,0-1.64,6",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.54,375a9.6,9.6,0,0,0,1.35-13.51,9.32,9.32,0,0,0-1.29-1.3,20,20,0,0,0-4.19,8.95,7.51,7.51,0,0,0,0,3.65,3.49,3.49,0,0,0,2.59,2.44",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.8,396.54a1,1,0,0,0,0-.25v-.7c0-.61-.1-1.53-.13-2.71a24.34,24.34,0,0,1,1.6-9.74,14.84,14.84,0,0,1,3.87-5.48,10.46,10.46,0,0,1,7.12-2.62,8.8,8.8,0,0,1,4,1,7.92,7.92,0,0,1,3.09,3,15.87,15.87,0,0,1,1.8,8.94,64.16,64.16,0,0,0-.2,9.4,14.37,14.37,0,0,0,1.21,4.36,9.13,9.13,0,0,0,2.59,3.46,13.17,13.17,0,0,0,3.65,1.88,19.06,19.06,0,0,1,3.52,1.56,12.46,12.46,0,0,1,4.53,4.94,11.79,11.79,0,0,1,1.32,5.42,12.9,12.9,0,0,1-.69,4.18,15.9,15.9,0,0,1-1.62,3.25l.16-.18c.09-.13.25-.32.42-.57a12.94,12.94,0,0,0,1.22-2.44A12.76,12.76,0,0,0,241,419a11.91,11.91,0,0,0-1.28-5.56,12.72,12.72,0,0,0-4.61-5.12c-2.12-1.41-4.87-1.77-7.07-3.46a11,11,0,0,1-3.65-7.53,64.76,64.76,0,0,1,.22-9.34,16.31,16.31,0,0,0-1.89-9.19,8.41,8.41,0,0,0-3.28-3.12,9.46,9.46,0,0,0-4.21-1,10.85,10.85,0,0,0-7.38,2.76,15.17,15.17,0,0,0-4,5.66,20.48,20.48,0,0,0-1.35,5.55,31.18,31.18,0,0,0-.12,4.32,23,23,0,0,0,.2,2.7,5,5,0,0,0,.1.71Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.7,407.44a10.82,10.82,0,0,1,14.62-10.66,18.1,18.1,0,0,1-14.27,10.54"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.53,408.94c2.09,2.3,2,6,.46,8.72a19.67,19.67,0,0,1-6.66,6.39,14.08,14.08,0,0,1,6.09-15.95"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.39,398.16a12.49,12.49,0,0,1-13.67,11.19c-.18,0-.35,0-.53-.06.82-3.36,2.16-6.76,4.76-9s6.7-3.13,9.58-1.22"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.45,394.72c.53-3.06,3.55-5.27,6.64-5.56a12.79,12.79,0,0,1,8.64,2.89,11.23,11.23,0,0,1-15.3,1.52"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.4,420.78c2.93,2.5,3.65,7,2.43,10.64a17.79,17.79,0,0,1-7.3,8.73,23.2,23.2,0,0,1-1.37-11.31,11.89,11.89,0,0,1,6.44-9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.93,386.14a9,9,0,0,0-12.53-2.47,9.35,9.35,0,0,0-1.82,1.62,7.79,7.79,0,0,0,14.08.37"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.33,377.3A11.74,11.74,0,0,0,236,369.5a12.4,12.4,0,0,0,.32-1.37,26.57,26.57,0,0,0-7.07.1,11.44,11.44,0,0,0-6.26,3.08,6.21,6.21,0,0,0-1.64,6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.54,375a9.6,9.6,0,0,0,1.35-13.51,9.32,9.32,0,0,0-1.29-1.3,20,20,0,0,0-4.19,8.95,7.51,7.51,0,0,0,0,3.65,3.49,3.49,0,0,0,2.59,2.44"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.8,396.54a1,1,0,0,0,0-.25v-.7c0-.61-.1-1.53-.13-2.71a24.34,24.34,0,0,1,1.6-9.74,14.84,14.84,0,0,1,3.87-5.48,10.46,10.46,0,0,1,7.12-2.62,8.8,8.8,0,0,1,4,1,7.92,7.92,0,0,1,3.09,3,15.87,15.87,0,0,1,1.8,8.94,64.16,64.16,0,0,0-.2,9.4,14.37,14.37,0,0,0,1.21,4.36,9.13,9.13,0,0,0,2.59,3.46,13.17,13.17,0,0,0,3.65,1.88,19.06,19.06,0,0,1,3.52,1.56,12.46,12.46,0,0,1,4.53,4.94,11.79,11.79,0,0,1,1.32,5.42,12.9,12.9,0,0,1-.69,4.18,15.9,15.9,0,0,1-1.62,3.25l.16-.18c.09-.13.25-.32.42-.57a12.94,12.94,0,0,0,1.22-2.44A12.76,12.76,0,0,0,241,419a11.91,11.91,0,0,0-1.28-5.56,12.72,12.72,0,0,0-4.61-5.12c-2.12-1.41-4.87-1.77-7.07-3.46a11,11,0,0,1-3.65-7.53,64.76,64.76,0,0,1,.22-9.34,16.31,16.31,0,0,0-1.89-9.19,8.41,8.41,0,0,0-3.28-3.12,9.46,9.46,0,0,0-4.21-1,10.85,10.85,0,0,0-7.38,2.76,15.17,15.17,0,0,0-4,5.66,20.48,20.48,0,0,0-1.35,5.55,31.18,31.18,0,0,0-.12,4.32,23,23,0,0,0,.2,2.7,5,5,0,0,0,.1.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.49,388.89a8.88,8.88,0,0,1-.64-3.13,7.63,7.63,0,0,1,.84-3.66,7.71,7.71,0,0,1,6.24-4.11,8.89,8.89,0,0,1,3.07.36c2.1.55,4.17,1.74,6.65,2.23a7.65,7.65,0,0,0,3.86-.1,5.74,5.74,0,0,0,3.14-2.51c1.5-2.31,1.91-5.22,3.73-7.3a7.31,7.31,0,0,1,3.37-2.22,9.77,9.77,0,0,1,3.95-.4,10.13,10.13,0,0,1,6.57,3.42,15.35,15.35,0,0,1,3.26,6,18.32,18.32,0,0,1,.73,6,64.4,64.4,0,0,1-1.11,8.75c-.17,1-.31,1.79-.42,2.36l-.08.62v.22l.06-.21a3.06,3.06,0,0,1,.13-.61c.13-.58.28-1.36.5-2.35a58.93,58.93,0,0,0,1.22-8.77,18.18,18.18,0,0,0-.68-6.09,15.87,15.87,0,0,0-3.31-6.22,12,12,0,0,0-3-2.44,10.37,10.37,0,0,0-8-.77,7.72,7.72,0,0,0-3.58,2.36c-1.91,2.28-2.33,5.21-3.75,7.41a5.41,5.41,0,0,1-2.9,2.34,7.56,7.56,0,0,1-3.66.1c-2.43-.46-4.47-1.63-6.62-2.19a8.93,8.93,0,0,0-3.21-.34,7.76,7.76,0,0,0-7.23,8.08,7.81,7.81,0,0,0,.46,2.44A4.24,4.24,0,0,0,140.49,388.89Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.51,373.36a8.26,8.26,0,0,1-7.62.5,7.69,7.69,0,0,1-3.89-6.09,8.73,8.73,0,0,1,7.09-.36,8.63,8.63,0,0,1,4.72,5.28",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,380.71a8.29,8.29,0,0,1-3.53,6.79,7.73,7.73,0,0,1-7.31.12,8.14,8.14,0,0,1,10.34-7.47",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33,379.08a8.31,8.31,0,0,1-7.65-.3,7.76,7.76,0,0,1-3.2-6.49,8.73,8.73,0,0,1,7.09.4,8.63,8.63,0,0,1,4.13,5.69",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,368.49a8.71,8.71,0,0,0,3-7.17,7.68,7.68,0,0,0-4.71-5.53,8.21,8.21,0,0,0-.14,11.61,8.1,8.1,0,0,0,1.36,1.12",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.3,358.41a.82.82,0,0,0-.09-.19c-.07-.14-.17-.31-.28-.53-.27-.45-.67-1.12-1.22-1.93a21,21,0,0,0-6.09-5.79,14.93,14.93,0,0,0-5.51-2,13.44,13.44,0,0,0-6.68.69,10.84,10.84,0,0,0-5.71,4.68c-1.32,2.29-1.73,5-2.5,7.55a13.8,13.8,0,0,1-1.59,3.65,11,11,0,0,1-2.72,2.67c-1,.76-2.08,1.44-3.06,2.23a13.22,13.22,0,0,0-2.43,2.69,16.42,16.42,0,0,0-2.55,6.21,22.07,22.07,0,0,0-.34,5.85,45.14,45.14,0,0,0,1.5,8.31c.25,1,.46,1.7.61,2.2a5.49,5.49,0,0,0,.25.77,4.26,4.26,0,0,0-.16-.79c-.13-.55-.3-1.29-.53-2.23a49.45,49.45,0,0,1-1.34-8.28,22.17,22.17,0,0,1,.39-5.75,16.27,16.27,0,0,1,2.5-6.09,12.49,12.49,0,0,1,2.43-2.6c.95-.77,2-1.44,3-2.2a11.64,11.64,0,0,0,2.82-2.78,13.72,13.72,0,0,0,1.66-3.73c.78-2.62,1.22-5.26,2.43-7.45A10.41,10.41,0,0,1,212.6,349a13.26,13.26,0,0,1,6.48-.72,14.68,14.68,0,0,1,5.37,1.93,20.84,20.84,0,0,1,6.15,5.6c.6.79,1,1.44,1.31,1.88A4.8,4.8,0,0,0,232.3,358.41Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.68,367.84c.71-.66,1-.21,2,0a5.85,5.85,0,0,1,2.59,1.25,10.84,10.84,0,0,1,3.51,11.37A8.46,8.46,0,0,1,199,367.77",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.75,354.6c.36-.9.87-.63,1.81-.89a5.77,5.77,0,0,1,2.86,0,10.84,10.84,0,0,1,8.06,8.83A8.44,8.44,0,0,1,228,354.42",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,385.76a9.74,9.74,0,0,1,13.74-1,9.64,9.64,0,0,1,1.58,1.74,12.05,12.05,0,0,1-8,3.13,12.2,12.2,0,0,1-8-3.24",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.66,372.37a9.89,9.89,0,0,1-10.17-9.6,10,10,0,0,1,.18-2.19A8.87,8.87,0,0,1,195,372.29",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,356.65a9.85,9.85,0,0,1-13.32-7.81,8.86,8.86,0,0,1,13.6,7.61",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.33,351.51a9.87,9.87,0,0,1,12.76,5.67,9.29,9.29,0,0,1,.56,2.13,8.86,8.86,0,0,1-13.6-7.6",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7,350.46a9.9,9.9,0,0,1-5.26-14.52,8.87,8.87,0,0,1,5.61,14.54",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.18,351a9.88,9.88,0,0,1,5.92-12.66,10,10,0,0,1,2.16-.51,8.88,8.88,0,0,1-7.89,13.4",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.59 428.24 205.32 432.54 165.04 432.54 162.3 428.24 208.59 428.24",
    fill: "#2f2e41",
    "data-secondary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,428.21c0,.12,9.89.24,22.09.24s22.11-.12,22.11-.24-9.89-.25-22.11-.25S163.19,428.06,163.19,428.21Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,428.21c0,.12,9.89.24,22.09.24s22.11-.12,22.11-.24-9.89-.25-22.11-.25S163.19,428.06,163.19,428.21Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.71,411.07a1.31,1.31,0,0,0,.25.33,7.39,7.39,0,0,0,.82.86,15.16,15.16,0,0,0,3.65,2.5,15.45,15.45,0,0,0,10.14,1.29,23.66,23.66,0,0,0,3.92-1.29,71.34,71.34,0,0,1,7.24-3.11,12.54,12.54,0,0,1,6.28-.59,8.08,8.08,0,0,1,3.83,1.77,13.25,13.25,0,0,1,1.1,1.15,1.3,1.3,0,0,0-.19-.37,6.15,6.15,0,0,0-.78-.91,8.1,8.1,0,0,0-3.9-2,12.54,12.54,0,0,0-6.54.53c-2.37.72-4.75,2-7.31,3.07a22.51,22.51,0,0,1-3.84,1.29,14.69,14.69,0,0,1-3.74.34,16.05,16.05,0,0,1-6.16-1.48A19.59,19.59,0,0,1,167.71,411.07Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.32,407.93a1.76,1.76,0,0,0,.26.31c.29.29.58.55.89.81a16.7,16.7,0,0,0,3.73,2.31,17.4,17.4,0,0,0,10.18,1.26,27.53,27.53,0,0,0,4-1.14c2.65-1,5.09-2.07,7.43-2.73a14.85,14.85,0,0,1,6.32-.57,9.59,9.59,0,0,1,4,1.52,12.52,12.52,0,0,1,1.22,1,2,2,0,0,0-.26-.34,7.3,7.3,0,0,0-.87-.8,9.12,9.12,0,0,0-4.05-1.71,14.56,14.56,0,0,0-6.49.49c-2.38.64-4.87,1.74-7.47,2.69a24.23,24.23,0,0,1-3.91,1.12,16.8,16.8,0,0,1-3.75.28,18.19,18.19,0,0,1-6.22-1.38A21.43,21.43,0,0,1,167.32,407.93Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.6,
    y: 392.56,
    width: 8.06,
    height: 55.21,
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.67,400.11a17.8,17.8,0,0,1-6.9,0A17.06,17.06,0,0,1,152.67,400.11Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.82,398.89a17.11,17.11,0,0,1-6.91,0A17.85,17.85,0,0,1,152.82,398.89Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.07,435.09c-.2,0-.36-6.32-.36-14.12s.16-14.13.36-14.13.34,6.33.34,14.13S149.26,435.09,149.07,435.09Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.56,
    y: 432.74,
    width: 55.93,
    height: 14.75,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,444a1.69,1.69,0,0,1-.29.17c-.21.1-.5.25-.9.42A15.08,15.08,0,0,1,204,445.7a9.25,9.25,0,0,1-5.92-.8,7.9,7.9,0,0,1-2.81-2.61,6.15,6.15,0,0,1-1-4.25,4.56,4.56,0,0,1,1-2.19,2.77,2.77,0,0,1,2.28-1.06,3.28,3.28,0,0,1,2.29,1.21,4.61,4.61,0,0,1,1,2.53,6.74,6.74,0,0,1-1.85,5.22,8.16,8.16,0,0,1-5.19,2.6,13.48,13.48,0,0,1-6-.77,10.94,10.94,0,0,1-5.26-3.66,5.91,5.91,0,0,1-1.22-3.18,4.23,4.23,0,0,1,1.14-3.31,2.58,2.58,0,0,1,1.7-.75,2.9,2.9,0,0,1,1.71.47,4.76,4.76,0,0,1,2,3,7,7,0,0,1-2.12,6.49,10.41,10.41,0,0,1-6.09,2.53,14.74,14.74,0,0,1-6.29-.63,8.73,8.73,0,0,1-4.78-3.81,6.6,6.6,0,0,1-.6-5.86,3,3,0,0,1,2.19-1.92,3.53,3.53,0,0,1,2.72.67,4.68,4.68,0,0,1,1.28,5,8.39,8.39,0,0,1-2.72,3.93,12,12,0,0,1-7.39,2.94,11.57,11.57,0,0,1-5.85-1.36,11.7,11.7,0,0,1-3.05-2.31,9.93,9.93,0,0,1-.65-.77,3,3,0,0,1-.2-.29,14.35,14.35,0,0,0,4,3.13,11.49,11.49,0,0,0,5.73,1.21,11.78,11.78,0,0,0,7.1-2.92,8.22,8.22,0,0,0,2.52-3.65,4.13,4.13,0,0,0-1.12-4.36,2.85,2.85,0,0,0-2.27-.55,2.41,2.41,0,0,0-1.76,1.57,6.1,6.1,0,0,0,.59,5.29,8.05,8.05,0,0,0,4.46,3.5,14.08,14.08,0,0,0,6,.59,9.72,9.72,0,0,0,5.68-2.36,6.36,6.36,0,0,0,1.93-5.83,4.11,4.11,0,0,0-1.68-2.54,2,2,0,0,0-2.63.16,3.48,3.48,0,0,0-.94,2.76,5.39,5.39,0,0,0,1.08,2.83,10.42,10.42,0,0,0,4.94,3.39,12.94,12.94,0,0,0,5.72.76,7.55,7.55,0,0,0,4.87-2.44,6.15,6.15,0,0,0,1.73-4.75,3.46,3.46,0,0,0-2.79-3.3,2.31,2.31,0,0,0-1.87.87,3.9,3.9,0,0,0-.89,1.93,5.79,5.79,0,0,0,.86,3.93,7.89,7.89,0,0,0,2.65,2.52,9.11,9.11,0,0,0,5.71.92,15.89,15.89,0,0,0,3.65-.92A11,11,0,0,1,208.88,444Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.42,
    y: 397.26,
    width: 25.22,
    height: 50.39,
    fill: "#2f2e41",
    "data-secondary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65,405.61A102.51,102.51,0,0,1,133,406a100.1,100.1,0,0,1-11.62-.35,95.86,95.86,0,0,1,11.62-.35A96,96,0,0,1,144.65,405.61Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.45,409.41a94.67,94.67,0,0,1-11.42.36,92.76,92.76,0,0,1-11.43-.36,99.05,99.05,0,0,1,11.43-.34A101.24,101.24,0,0,1,144.45,409.41Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.79,437.37a98.24,98.24,0,0,1-11.76.35,98.34,98.34,0,0,1-11.77-.35A102.7,102.7,0,0,1,133,437,102.59,102.59,0,0,1,144.79,437.37Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.86,
    y: 449.36,
    width: 233.59,
    height: 13.84,
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.86,
    y: 449.36,
    width: 233.59,
    height: 13.84,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,527.44H474a0,0,0,0,1,0,0v9a8.6,8.6,0,0,1-8.6,8.6H439a8.6,8.6,0,0,1-8.6-8.6v-9A0,0,0,0,1,430.4,527.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.74,428.13h23a5.92,5.92,0,0,1,5.92,5.92v65.87a5.92,5.92,0,0,1-5.92,5.92h-23a0,0,0,0,1,0,0V428.13A0,0,0,0,1,706.74,428.13Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.32,527.24h43.58a0,0,0,0,1,0,0v9a8.6,8.6,0,0,1-8.6,8.6H656.92a8.6,8.6,0,0,1-8.6-8.6v-9A0,0,0,0,1,648.32,527.24Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.46,360.87V511.44c0,.18,0,.36,0,.53a16.51,16.51,0,0,1-.15,2,20.58,20.58,0,0,1-20.43,18H424.47A20.58,20.58,0,0,1,404,514a14.71,14.71,0,0,1-.14-2,4.61,4.61,0,0,1,0-.53V360.87c0-.44,0-.88.05-1.31a20.58,20.58,0,0,1,20.54-19.28h270.4a20.58,20.58,0,0,1,20.54,19.28C715.45,360,715.46,360.43,715.46,360.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.46,360.87v.69H403.88v-.69c0-.44,0-.88.05-1.31H715.41C715.45,360,715.46,360.43,715.46,360.87Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.45,512a16.51,16.51,0,0,1-.15,2H404a14.71,14.71,0,0,1-.14-2Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.21,
    y: 382.92,
    width: 74.36,
    height: 2,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.21,
    y: 389.68,
    width: 74.36,
    height: 2,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.6,
    y: 486.78,
    width: 74.36,
    height: 2,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.99,
    cy: 437.08,
    rx: 69.64,
    ry: 69.75,
    fill: "#0071f2",
    opacity: 0.3,
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.99,
    cy: 437.08,
    rx: 64.07,
    ry: 64.17,
    fill: "#0071f2",
    opacity: 0.3,
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.77,428.56s-22.71-45.86,3.86-48.86c0,0,31.63-6,36.46,12.95a7.72,7.72,0,0,1-.61,5.36c-1.13,2.19-3.52,5.17-8.56,7.95a31.4,31.4,0,0,0-9.23,7.44c-2.61,3.15-5.26,7.38-6.06,12.16l-11.14,4.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.32,431s51,3.69,40.15,28.11c0,0-10.87,30.31-29.65,24.85a7.67,7.67,0,0,1-4.31-3.25c-1.32-2.08-2.67-5.65-2.51-11.4a31.54,31.54,0,0,0-1.73-11.73c-1.39-3.85-3.69-8.28-7.41-11.39l2-11.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.22,452.6s-30.56,41-45.29,18.74c0,0-19.71-25.46-5-38.36a7.63,7.63,0,0,1,5.05-1.89c2.47,0,6.2.78,11,4A31.7,31.7,0,0,0,476.76,440c4,.89,9,1.33,13.59-.13l8.87,8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.99,
    cy: 437.08,
    rx: 54.34,
    ry: 54.43,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.99,
    cy: 437.08,
    rx: 45.46,
    ry: 45.53,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.99,
    cy: 437.08,
    rx: 35.27,
    ry: 35.32,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.99,
    cy: 437.08,
    rx: 25.81,
    ry: 25.85,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.45,
    y1: 405.05,
    x2: 558.33,
    y2: 469.02,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.72,
    y1: 381.72,
    x2: 534.27,
    y2: 493.08,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.62,
    y1: 372.76,
    x2: 501.62,
    y2: 501.11,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.92,
    y1: 437.08,
    x2: 567.84,
    y2: 437.08,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.15,
    y1: 469.21,
    x2: 557.96,
    y2: 404.29,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 533.52,
    y1: 380.78,
    x2: 469.72,
    y2: 492.15,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 502.45,
    cy: 437.32,
    r: 15.81,
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502.45,
    cy: 437.32,
    r: 13.17,
    fill: "#fff"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.23,
    cy: 645.55,
    rx: 96.76,
    ry: 13.88,
    fill: "#fff",
    opacity: 0.48
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "119.05 257.24 370.46 257.24 370.46 146.62 133.57 146.62 119.05 257.24",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.05 257.24 370.46 257.24 370.46 146.62 133.57 146.62 119.05 257.24",
    fill: "#fff",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145.87,
    y: 156.67,
    width: 206.72,
    height: 79.34,
    fill: "#fff",
    opacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145.87,
    y: 156.67,
    width: 206.72,
    height: 5.59,
    fill: "#fff",
    opacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 159.28,
    y: 165.61,
    width: 35.76,
    height: 4.47,
    fill: "#0071f2",
    opacity: 0.2,
    "data-primary": "true"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 159.28,
    y: 172.32,
    width: 35.76,
    height: 4.47,
    fill: "#0071f2",
    opacity: 0.2,
    "data-primary": "true"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 159.28,
    y: 179.02,
    width: 35.76,
    height: 4.47,
    fill: "#0071f2",
    opacity: 0.2,
    "data-primary": "true"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 159.28,
    y: 185.73,
    width: 35.76,
    height: 4.47,
    fill: "#0071f2",
    opacity: 0.2,
    "data-primary": "true"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 198.38,
    y: 165.61,
    width: 136.88,
    height: 4.47,
    opacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 198.38,
    y: 172.32,
    width: 136.88,
    height: 4.47,
    opacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 198.38,
    y: 179.02,
    width: 136.88,
    height: 4.47,
    opacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 198.38,
    y: 185.73,
    width: 136.88,
    height: 4.47,
    opacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 159.28,
    y: 209.19,
    width: 35.76,
    height: 4.47,
    fill: "#0071f2",
    opacity: 0.2,
    "data-primary": "true"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 159.28,
    y: 215.89,
    width: 35.76,
    height: 4.47,
    fill: "#0071f2",
    opacity: 0.2,
    "data-primary": "true"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 159.28,
    y: 222.6,
    width: 35.76,
    height: 4.47,
    fill: "#0071f2",
    opacity: 0.2,
    "data-primary": "true"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 159.28,
    y: 229.3,
    width: 35.76,
    height: 4.47,
    fill: "#0071f2",
    opacity: 0.2,
    "data-primary": "true"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 198.38,
    y: 209.19,
    width: 136.88,
    height: 4.47,
    opacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 198.38,
    y: 215.89,
    width: 136.88,
    height: 4.47,
    opacity: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 198.38,
    y: 222.6,
    width: 136.88,
    height: 4.47,
    opacity: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 198.38,
    y: 229.3,
    width: 136.88,
    height: 4.47,
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169.89,
    cy: 199.69,
    r: 5.03,
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.42,
    cy: 199.69,
    r: 5.03,
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M373.82,87.39s-23.72,16.71-21.92,59.2l-218.32,0s-3.36-2.24-15.65,0c0,0,10.06-46.93,32.41-59.23Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.82,87.39s-23.72,16.71-21.92,59.2l-218.32,0s-3.36-2.24-15.65,0c0,0,10.06-46.93,32.41-59.23Z",
    fill: "#fff",
    opacity: 0.4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 150.34,
    y: 81.81,
    width: 238.01,
    height: 5.59,
    fill: "#0071f2",
    "data-primary": "true"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.93,146.62s4.55-16.35,7.86-24.38c0,0,165.33,7.89,230.7-9a103.14,103.14,0,0,0-4.59,33.36l-218.32,0S129.11,144.38,117.93,146.62Z",
    fill: "#fff",
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.93,146.62s31.29-6.71,35.76,17.87l1.05,68.59a6.8,6.8,0,0,1-3.46,6l-32.23,18.13Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.93,146.62s31.29-6.71,35.76,17.87l1.05,68.59a6.8,6.8,0,0,1-3.46,6l-32.23,18.13Z",
    fill: "#fff",
    opacity: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 313.27,
    y: 158.48,
    width: 17.6,
    height: 1.68,
    transform: "translate(27.58 -46.57) rotate(8.64)",
    fill: "#d1d3d4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "313.24 158.82 310.87 158.8 311.24 156.4 313.49 157.17 313.24 158.82",
    fill: "#d1d3d4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M347.91,161.15l-12-1.83a9.32,9.32,0,0,1-3.25-1.13l-2.92-1.67a1.06,1.06,0,0,0-.34-.12l-1.11-.17a.68.68,0,0,0-.77.57l-1,6.45a.68.68,0,0,0,.57.77l1.06.16a.82.82,0,0,0,.35,0l3.36-.73a9.48,9.48,0,0,1,3.4-.11l12.05,1.83a2,2,0,0,0,2.31-1.7h0A2,2,0,0,0,347.91,161.15Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M466.19,605.78c-5,7.36-15.68,6.17-15.68,6.17v0L438,588l-4-7.67-6.54-12.54,24.23-7.6a21.8,21.8,0,0,1,4.36,7.28,39.66,39.66,0,0,1,1.46,4.61,62.14,62.14,0,0,1,1.78,12.1C458.83,594.62,466.19,605.78,466.19,605.78Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M427.48,567.77,434,580.31s17-4.27,22.14-12.9a22.37,22.37,0,0,0-4.38-7.24Z",
    fill: "#f9b499"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M401.17,221.85a65,65,0,0,1,4.69,7.32A98.24,98.24,0,0,1,416,256.38c7.26,33.41,12.26,87.38,12.26,87.38l-107.77-4.91,3.94-58.26a7.19,7.19,0,0,0-1.56-5l-23.2-27a2.13,2.13,0,0,1,.23-2.9c7.8-7.06,17.53-21.32,20-25.92a1.45,1.45,0,0,1,2.13-.48L346.6,237c5.69,4.12,15.7,3.43,15.7,3.43s3.73-3.24,7.07-11.48l23-11Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M454.92,545.08c-11.18,11.46-37.37,11.19-37.37,11.19l-14.18-40.93c-8.19-16.91-13.65-42.84-13.65-42.84l-7.64-50.2c-2,13.58-6.93,33.49-8.81,40.82a27.43,27.43,0,0,0-.86,6.24c-.25,10.28.27,28.9.94,46.93.94,24.61,2.18,48.17,2.18,48.17-13.37,8.72-38.19,6.26-38.19,6.26-2.46-18-14.75-105-14.75-105-4.5-44.52-5.37-78.4-5.2-100.38,0-.4,0-.8,0-1.2,0-3.57.09-6.82.17-9.73q0-.5,0-1c0-.14,0-.27,0-.4,0-.45,0-.89,0-1.31,0-1.2.08-2.34.12-3.41l0-.71a1.09,1.09,0,0,1,0-.18c0-.64.05-1.25.07-1.84,0-.12,0-.24,0-.36,0-.69.07-1.35.1-2l0-.62c0-.58.07-1.14.1-1.65.1-1.75.2-3,.27-3.91a1,1,0,0,1,1.28-.9c.34.09.68.18,1,.25,19.21,4.53,30.16-9.18,36.16-22.73.49-1.11,1-2.23,1.39-3.35.21-.54.41-1.08.6-1.63s.3-.83.44-1.24l.27-.8c.11-.33.21-.65.31-1s.15-.51.23-.76c.13-.44.26-.87.37-1.31.33-1.14.62-2.28.88-3.43.14-.59.27-1.18.39-1.76.24-1.15.45-2.3.62-3.46.1-.56.18-1.12.25-1.69a.25.25,0,0,0,0-.08c.08-.5.14-1,.19-1.5,0-.16,0-.31.05-.47q.11-.77.15-1.53c.12-1.16.19-2.31.24-3.47a82.8,82.8,0,0,0-1.4-19.34,147.44,147.44,0,0,0-7.77-26.3,2.21,2.21,0,0,1-.16-.82,2,2,0,0,1,2-2,17.29,17.29,0,0,1,2.56.29A2,2,0,0,1,360,239.3c3.74,9.1,13.91,43.8,13.91,43.8,3.53,13.24,7.95,21.31,10.67,25.38a28.58,28.58,0,0,0,2.49,3.28c8.44,11.59,15.12,2.16,15.12,2.16,4.7-6.28,2.75-30,2.75-30-1-25.71-5.12-38-5.12-38a66.86,66.86,0,0,0,.29-10.23c17.74,8.46,20.2,98.78,20.2,98.78.54,10.09,7.78,8.13,7.78,8.13,7.79-5,5.85,15.6,5.85,15.6-1.3,31.86-.86,80.11-.63,98.17a57.53,57.53,0,0,0,1.91,14l18.2,68.92Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M363.25,286.15a76.21,76.21,0,0,1-6.38,27.53c-6,13.55-17,27.24-36.22,22.71l0-.43.11-1.62c33.19-2.55,36.6-36.71,36.6-36.71,4.85-29.64-7.35-58.24-7.67-59a11.67,11.67,0,0,0,4.19,1.1h0a2.17,2.17,0,0,0,.16.82,147.62,147.62,0,0,1,7.77,26.31A83.17,83.17,0,0,1,363.25,286.15Z",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M375.53,564.46c-13.37,8.72-38.19,6.26-38.19,6.26-2.46-18-14.75-105-14.75-105-4.5-44.52-5.37-78.4-5.2-100.38,0-.4,0-.8,0-1.2,0-3.57.09-6.82.17-9.73q0-.5,0-1c0-.14,0-.27,0-.4,0-.45,0-.88,0-1.31,0-1.2.08-2.34.12-3.41l0-.71a1.09,1.09,0,0,1,0-.18c0-.64.05-1.26.07-1.84,0-.12,0-.24,0-.36,0-.7.06-1.35.1-2l0-.62c0-.58.07-1.14.1-1.65.1-1.74.2-3,.26-3.91a1,1,0,0,1,1.3-.9c.34.1.68.18,1,.25,19.21,4.53,30.16-9.18,36.16-22.73.49-1.11,1-2.23,1.39-3.35.21-.54.41-1.08.6-1.63s.3-.82.44-1.24l.27-.8c.1-.32.2-.65.31-1s.15-.51.23-.76c.13-.43.25-.87.37-1.31.32-1.13.61-2.28.88-3.43.14-.59.27-1.18.39-1.76.23-1.15.44-2.3.62-3.46.09-.56.17-1.12.25-1.69a.25.25,0,0,0,0-.08c.07-.5.13-1,.19-1.5,0-.16,0-.31.05-.47q.09-.77.15-1.53c.11-1.15.18-2.31.24-3.47,1.34,27.83-6.95,42.14-16.79,49.41-3,8.56-10.11,32.16-11.25,70.26,0,0,0,86.27,6.77,114,0,0,4.13,38.57,17.08,36.51,0,0,14.13,3.82,13.84-40.34l.45.27C374.29,540.9,375.53,564.46,375.53,564.46Z",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M454.93,545.08c-11.19,11.47-37.38,11.19-37.38,11.19l-14.18-40.92c-8.19-16.92-13.65-42.85-13.65-42.85l-7.64-50.2,4.66-20.53,14.43,73.91s5.3,25.62,20,48c0,0,11.2,27.38,24.14,21.79l8.06-6.2Z",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M370.37,581v0a49.69,49.69,0,0,1-.35,6.08v0c-.25,2.19-.61,4.33-1,6.34a90.71,90.71,0,0,1-3.32,11.91c-2.47,9.07-1.37,20.89-1.37,20.89-13.74,2.2-15.67-.83-15.67-.83l-.55-10.71c-.78-6.9-1.35-12.66-1.75-17.31-.27-3.16-.47-5.81-.62-8v0c-.12-1.77-.2-3.19-.26-4.27l.77-.06.5,0,.55,0,.58-.06a136.38,136.38,0,0,0,16.73-2.49l.23-.05C366.7,582,368.57,581.49,370.37,581Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M373.64,644.65l-66.7-.1c-.85-5.29,16-11.83,23.84-14.55l1-.34,2-.66a10.07,10.07,0,0,0,1.66-.7l1.14-.6c.32-.17.63-.33.93-.47a32.81,32.81,0,0,1,4.68-1.92l1-.29c4.49-1.17,5.53.39,5.53.39s1.93,3,15.67.83C375.29,618.82,373.64,644.65,373.64,644.65Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M370.37,581a50.35,50.35,0,0,1-.35,6.12c-12.4,5-22.2,2.87-24.31,2.31-.12-1.77-.2-3.19-.26-4.27l.77-.06.5,0,.55,0,.58-.06c1.5-.15,4.43-.54,16.73-2.49l.23-.05C366.71,582,368.59,581.51,370.37,581Z",
    fill: "#f9b499"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.63 648.09 306.88 648.09 306.94 644.55 373.63 644.66 373.63 648.09",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M480.92,620.26l-61,25.42c-6.14-2.69,5.38-14,14.72-22l.77-.64c1.51-1.27,2.94-2.45,4.21-3.47l.78-.63c2.66-2.12,4.46-3.46,4.46-3.46l.15-.22c.2-.3.39-.58.59-.83,2.95-3.93,4.75-2.69,4.94-2.54v0s10.69,1.19,15.68-6.17C472.13,594.37,480.92,620.26,480.92,620.26Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.88 645.69 422.02 649.72 482.54 623.5 480.92 620.26 419.88 645.69",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M439.7,627.39l-.71.71-4.39-4.38.77-.64Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M444.85,623.45l-.71.71-4.56-4.55.78-.63Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M450.48,619.37l-.71.71L445,615.3c.2-.3.39-.58.59-.83Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M332.79,635.44l-1,.18-1-5.62,1-.34Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M338.47,632.83l-1,.18-1-5.31c.32-.17.63-.33.93-.47Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M344,630.07l-1,.18-.9-4.94,1-.29Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M370,587.06v0c-.25,2.19-.61,4.33-1,6.34-6.73,5.75-20.18,4.28-22.66,3.95-.27-3.16-.47-5.81-.62-8A40.75,40.75,0,0,0,370,587.06Z",
    fill: "#fff",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M404.44,315.6a9.7,9.7,0,0,1-11.5,3.89c-6.53-2.56-8.5-11-8.5-11l.11,0,0,0a28.28,28.28,0,0,0,2.47,3.26c8.44,11.58,15.12,2.15,15.12,2.15,4.7-6.28,2.75-30,2.75-30-1-25.71-5.12-38-5.12-38,.1-4.07.29-10.22.29-10.22a6.47,6.47,0,0,1,2.43,2c4.4,8.8,6.11,44,6.11,44C410.65,301.25,407.59,310.9,404.44,315.6Z",
    opacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M402.16,313.92s-6.68,9.43-15.12-2.15a28.28,28.28,0,0,1-2.47-3.26c.45.34,9.64,7.36,14.1-.83,0,0,6.22-11.52,1.12-61.78,0,0,4.13,12.27,5.12,38C404.91,283.88,406.86,307.64,402.16,313.92Z",
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M319.08,221.19c-10.68,17-19.17,24.51-19.17,24.51l-5.58-6.56a45.06,45.06,0,0,1-8.87-13.31,12.65,12.65,0,0,1-.83-3c-1.93-12.76-4.61-58.43-4.61-58.43a150.65,150.65,0,0,0-6.31-16.24c-3.62-5.83,3.89-7.28,3.89-7.28,8-3.95,13.61-2.19,17.06.24a15.37,15.37,0,0,1,2.51,2.23,10.06,10.06,0,0,1,1.84,2.93,8.8,8.8,0,0,1,.58,1.91,22.46,22.46,0,0,1-2.79,15,8.82,8.82,0,0,0-1,6.24l8,36.42C305.73,213.43,319.08,221.19,319.08,221.19Z",
    fill: "#f9b499"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M299,146.32c-1.41,6.68-3.23,7.21-3.23,7.21a20.52,20.52,0,0,0-1.12-12.37,15.37,15.37,0,0,1,2.51,2.23A10.06,10.06,0,0,1,299,146.32Z",
    fill: "#f7a48b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M338.14,159.7s-4.43,3.54,3.19,10.19a149.19,149.19,0,0,0,16.3,10,10.36,10.36,0,0,1,3.83,3.37L369,194.32l7.18-6-4.5-14.09-2.55-4.51s-15.91-25.86-26.3-15.7Z",
    fill: "#f9b499"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M338.14,159.7a32.92,32.92,0,0,1,5.15,3.34,33.56,33.56,0,0,1,4.55,4.14,33.55,33.55,0,0,1-5.16-3.35A34,34,0,0,1,338.14,159.7Z",
    fill: "#f7a48b"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M341.35,156.31a17.42,17.42,0,0,1,6.92,4.57,15.55,15.55,0,0,1-3.74-1.86A16,16,0,0,1,341.35,156.31Z",
    fill: "#f7a48b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M343.79,152.93a25.07,25.07,0,0,1,8.46,5.33,22.49,22.49,0,0,1-4.5-2.24A23,23,0,0,1,343.79,152.93Z",
    fill: "#f7a48b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M349.77,151.68a10.88,10.88,0,0,1,5,4.19,9.46,9.46,0,0,1-2.82-1.71A9.82,9.82,0,0,1,349.77,151.68Z",
    fill: "#f7a48b"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M378,172.56a10.12,10.12,0,0,1-1.55,2.38,21.4,21.4,0,0,0-2.68,3.92c-1.13,2.18-2.42,5.27-2.16,7.51,0,0-.51,1.34-1,3.1,0,0-5.59-1.16-5.19-11.12a16.29,16.29,0,0,1,1.93-7.24c1.48-2.61,4-5.29,8.26-4.32C375.55,166.79,379.92,168.3,378,172.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M378,172.56a10.12,10.12,0,0,1-1.55,2.38,21.4,21.4,0,0,0-2.68,3.92c-1.13,2.18-2.42,5.27-2.16,7.51,0,0-2.61-1.43-.45-9.86C371.13,176.51,373.08,169.66,378,172.56Z",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M369.37,228.92a37.87,37.87,0,0,1-7.07,11.48s2.65,6.19,18.85,2.65l-.89-10.6s-2.94,0-5.59-6.18Z",
    fill: "#f9b499"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M408.08,198.34c-20-12.5-32.72-9.15-37.87-6.65.08-.73.19-1.47.34-2.22,0,0,2.94-15.9,20-9.72C390.57,179.75,404.69,185.51,408.08,198.34Z",
    fill: "#fff",
    opacity: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M369.81,226.62a19.92,19.92,0,0,1-2.79,7.23l22.43.14-6.36-4.57Z",
    fill: "#f7a48b"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.39,
    cy: 209.27,
    rx: 22.53,
    ry: 16.89,
    transform: "translate(49.42 488.32) rotate(-70.63)",
    fill: "#f9b499"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M370.94,215.87s3.53,14.91,8.64,16.49l.38-9.63a48.21,48.21,0,0,1-5.73-9.12A4.81,4.81,0,0,1,370.94,215.87Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M408.53,207.71a40.62,40.62,0,0,1-9.12,19.45S403,253.9,394,260.58a3.37,3.37,0,0,1-3.88,0c-4-2.72-12.39-11.65-10.13-37.82,0,0-11.91-13.81-9.75-31,.08-.73.19-1.47.34-2.22,0,0,2.94-15.9,20-9.72,0,0,14.12,5.76,17.51,18.59A22.74,22.74,0,0,1,408.53,207.71Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M408.53,207.71a40.62,40.62,0,0,1-9.12,19.45S403,253.9,394,260.58a3.37,3.37,0,0,1-3.88,0c-4-2.72-12.39-11.65-10.13-37.82,0,0-11.91-13.81-9.75-31,.08-.73.19-1.47.34-2.22,0,0,2.94-15.9,20-9.72,0,0,14.12,5.76,17.51,18.59A22.74,22.74,0,0,1,408.53,207.71Z",
    opacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M380,222.74a31.73,31.73,0,0,0,4.19,3.78,17.71,17.71,0,0,0,4.84,2.64,10.11,10.11,0,0,0,5.37.35,13.7,13.7,0,0,0,5-2.36,10.77,10.77,0,0,1-4.84,3.12,9.8,9.8,0,0,1-5.87-.16,15.19,15.19,0,0,1-5-3A18.73,18.73,0,0,1,380,222.74Z",
    opacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M371.13,187.3a12.71,12.71,0,0,0-4.51,1.18s-1.28,11.68,3.34,20.12l1.76-1S368.29,196.92,371.13,187.3Z",
    fill: "#f7a48b"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.94,
    cy: 211.35,
    rx: 5.3,
    ry: 4.09,
    transform: "translate(-40.8 324.2) rotate(-45)",
    fill: "#f9b499"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M379.68,572.27c0,5.59-2.66,6.18-2.66,6.18a41.77,41.77,0,0,1-6.61,2.49h0c-9.6,2.9-21.31,3.93-24.92,4.19l-1.12.08c-9.41,1.17-8.82-7.36-8.82-7.36-2.06-8.25,1.83-7.13,1.83-7.13,27.15,1.7,38.19-6.27,38.19-6.27C381.09,560.19,379.68,572.27,379.68,572.27Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M417.55,556.27s-3.72.39-.48,7.45c0,0,.59,8.54,6.48,6.19,0,0,14.43-1.18,33-8.25,0,0,4.42-1.17,2.94-8.54,0,0,1.18-10.89-4.54-8C454.93,545.08,446.21,555.43,417.55,556.27Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M457.53,572.06c-2.85,9-16.53,14.77-19.51,15.92l-4-7.67c2.52-.7,17.54-5.14,22.05-12.86A39.66,39.66,0,0,1,457.53,572.06Z",
    fill: "#fff",
    opacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirconditionerrepair);
export default __webpack_public_path__ + "static/media/Air conditioner repair.0018e85aa7ce5b3c9bb62330b49bc225.svg";
export { ForwardRef as ReactComponent };